export default "__VITE_ASSET__BwdRLWjo__"